import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ContactForm from "@/components/ContactForm";

export default function Contact() {
  return (
    <main className="min-h-screen text-white flex flex-col px-6 md:px-12 py-10" data-testid="contact-page">
      <header className="mb-12 md:mb-16">
        <Link to="/" className="vintage-link text-xs sm:text-sm uppercase" data-testid="contact-back">
          ← Back
        </Link>
      </header>

      <div className="flex-1 flex flex-col items-center justify-center w-full">
        <div className="w-full max-w-xl">
          <h1
            className="vintage-text text-5xl sm:text-6xl md:text-7xl leading-[0.95] text-center mb-12 mm-fade-in"
            data-testid="contact-title"
          >
            Contact
          </h1>
          <ContactForm />
        </div>
      </div>
    </main>
  );
}
